import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { LeaveGuard, LeaveGuardProps } from "@/components/LeaveGuard/LeaveGuard";

type ScoreLeaveGuardProps = Pick<LeaveGuardProps, "when" | "onSave" | "onDiscard">;

/**
 * The Lead Scoring pages' leave guard: the shared `LeaveGuard` bound to this area's copy.
 *
 * The behaviour moved to `@/components/LeaveGuard` when the campaign builder needed the same three
 * choices (PREC-4194) — one implementation, so a fix to either screen's wording or button order
 * cannot drift from the other. This wrapper exists so the five Lead Scoring pages keep importing
 * `ScoreLeaveGuard` unchanged; it can be inlined whenever that area is next touched.
 */
export const ScoreLeaveGuard: FunctionComponent<ScoreLeaveGuardProps> = ({
	when,
	onSave,
	onDiscard,
}) => {
	const { t } = useTranslation();

	return (
		<LeaveGuard
			body={t("leadScoring.shell.leaveBody")}
			discardLabel={t("leadScoring.shell.discardAndLeave")}
			onDiscard={onDiscard}
			onSave={onSave}
			saveLabel={t("leadScoring.shell.saveAndLeave")}
			title={t("leadScoring.leaveTitle")}
			when={when}
		/>
	);
};
